export const isMobileDevice = () => {
  if (typeof navigator !== 'undefined') {
    // Verificar si el navegador soporta userAgentData
    if ('userAgentData' in navigator && typeof navigator.userAgentData?.mobile === 'boolean') {
      return navigator.userAgentData.mobile;
    }

    // Fallback para navegadores que no soportan userAgentData
    return /Mobi|Android|iPhone|iPad|iPod|Kindle|Silk|BlackBerry|BB10|Opera Mini|IEMobile|Mobile|Tablet/i.test(navigator.userAgent);
  }
  return false;
};
